var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceptionsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "receptions-icon_svg__a",
    d: "M0 .705h44.706v12.042H.001z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "receptions-icon_svg__c",
    d: "M.86.741h3.195V4H.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "receptions-icon_svg__e",
    d: "M.651.741h3.195V4H.651z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "receptions-icon_svg__g",
    d: "M0 23h44.706V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "receptions-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#receptions-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.672 11.075h41.362V2.377h-3.07v4.574a.836.836 0 01-.835.836H5.579a.836.836 0 01-.836-.836V2.377H1.672v8.698zm42.199 1.672H.837A.836.836 0 010 11.911V1.541C0 1.08.375.705.837.705h4.742c.46 0 .836.374.836.836v4.574h31.878V1.541c0-.462.374-.836.836-.836h4.742c.46 0 .836.374.836.836v10.37a.837.837 0 01-.836.836z",
    fill: "currentColor",
    mask: "url(#receptions-icon_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37 19)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "receptions-icon_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#receptions-icon_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.816.741H1.1a.239.239 0 00-.239.24v2.78c0 .132.107.24.24.24h2.716a.239.239 0 00.24-.24V.981a.239.239 0 00-.24-.24",
    fill: "currentColor",
    mask: "url(#receptions-icon_svg__d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 19)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "receptions-icon_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#receptions-icon_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.607.741H.89a.239.239 0 00-.239.24v2.78c0 .132.107.24.24.24h2.716a.239.239 0 00.24-.24V.981a.239.239 0 00-.24-.24",
    fill: "currentColor",
    mask: "url(#receptions-icon_svg__f)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.61 9.848h-1.672V1.672H4.386v8.176H2.714V.836c0-.462.375-.836.836-.836h38.224c.462 0 .836.374.836.836v9.012z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "receptions-icon_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#receptions-icon_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    mask: "url(#receptions-icon_svg__h)",
    d: "M6.39 12.499h32.738v-.955H6.39z"
  }))));
}
export default SvgReceptionsIcon;